import { BrowserModule, HAMMER_GESTURE_CONFIG } from '@angular/platform-browser';
import { NgModule } from '@angular/core';

import { AppRoutingModule } from './app-routing.module';
import { AppComponent } from './app.component';
import { ServiceWorkerModule } from '@angular/service-worker';
import { environment } from '@env/environment';
import { BrowserAnimationsModule } from '@angular/platform-browser/animations';
import { CoreModule } from './core/core.module';
import { ModalLegalComponent } from './ui/modal-legal/modal-legal.component';
import { SharedModule } from '@app/shared';
import { StaticModule } from './static/static.module';
import { SettingsModule } from './settings';
import { UiModule } from './ui/shared/ui.module';
import { PdfViewerModule } from 'ng2-pdf-viewer';
import { GestureConfig } from '@angular/material';

@NgModule({
  declarations: [
	AppComponent,
	ModalLegalComponent,
  ],
  imports: [

    BrowserModule,
    AppRoutingModule,
    CoreModule,
    SharedModule,

    // features
    StaticModule,
    SettingsModule,
    UiModule,
    PdfViewerModule,
    ServiceWorkerModule.register('ngsw-worker.js', { enabled: environment.production }),
    BrowserAnimationsModule,




  ],
  providers: [

	{provide: HAMMER_GESTURE_CONFIG, useClass: GestureConfig}

  ],
  entryComponents: [ModalLegalComponent],
  bootstrap: [AppComponent]
})
export class AppModule { }
